import React from 'react';

import { createHeldFlag } from './heldFlag';

/**
 * Home's deployment strip is on screen: the brand deploying, or its finished summary until the owner closes it. Home
 * holds it, the FTUX reads it: its pieces wait meanwhile (gate/useDeployed). Never set elsewhere, so the strip, and
 * Home, behave exactly as before.
 */
const deployStripShown = createHeldFlag();

/** Whether Home shows its deployment strip now. */
export const useDeployStripShown = deployStripShown.useHeld;

/**
 * Home publishes whether its deployment strip shows, while Home is mounted (false once it leaves). A layout effect,
 * so the FTUX hides a waiting pick card before Home paints next to the strip.
 */
export const usePublishDeployStrip = (shown: boolean): void => {
  React.useLayoutEffect(() => {
    deployStripShown.set(shown);
    return () => deployStripShown.set(false);
  }, [shown]);
};
